import { Component, OnInit } from '@angular/core';
import { CheckboxesService } from '../../services/checkboxes.service'



@Component({
  selector: 'app-serveis',
  templateUrl: './serveis.component.html',
  styleUrls: ['./serveis.component.css']
})
export class ServeisComponent implements OnInit {

  //CONSTANTS PER ARRAY SERVEIS
  RADAR = 0;
  GAS_STATION = 1;
  TRAMS_PERILL = 2;
  PARKING = 3;
  PARKANDRIDE = 4;

  serveis: string[] = ['RADAR','GAS_STATION','TRAMS_PERILL','PARKING','PARKANDRIDE'];
  checkboxes: boolean[] = [false,false,false,false,false];


  toggleCheckbox(layer: string){
    if(this.checkboxes[this.serveis.indexOf(layer)]) this.checkboxesService.deleteCheckbox(layer);
    else this.checkboxesService.addCheckbox(layer);
  }

  constructor(private checkboxesService: CheckboxesService) { }

  ngOnInit() {
    this.checkboxesService.getCheckboxes().subscribe(data => {
      for(var i = 0; i < 5; i++){
        if(data.includes(this.serveis[i])) this.checkboxes[i] = true;
        else this.checkboxes[i] = false;
      }
    })

  }




}
